/**
 * Outlook 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <OutlookIcon className="w-8 h-8" />
 * <OutlookIcon className="w-12 h-12" />
 * ```
 */
export function OutlookIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Outlook icon"
      role="img"
    >
      <title>Outlook</title>
      <g id="Outlook">
        <g id="Vector">
          <path
            d="M30 16.7C30.0015 16.4646 29.8884 16.2456 29.7017 16.1225H29.6985L29.6868 16.1155L19.9844 9.94149C19.9425 9.91106 19.8991 9.88325 19.8542 9.8582C19.4796 9.65043 19.0346 9.65043 18.66 9.8582C18.6151 9.88327 18.5716 9.91106 18.5297 9.94149L8.82743 16.1155L8.81572 16.1225C8.51919 16.3207 8.42828 16.7398 8.61268 17.0586C8.66701 17.1525 8.74185 17.2308 8.83069 17.2866L18.533 23.4606C18.575 23.4907 18.6185 23.5186 18.6632 23.5439C19.0379 23.7516 19.4829 23.7516 19.8575 23.5439C19.9022 23.5186 19.9457 23.4908 19.9877 23.4606L29.69 17.2866C29.8839 17.1651 30.0022 16.9412 30 16.7Z"
            fill="#0A2767"
          />
          <path
            d="M9.9585 12.5777H16.3256V18.8518H9.9585V12.5777ZM28.6977 6.19999V3.32999C28.7129 2.61243 28.1846 2.01719 27.5171 2H10.9945C10.327 2.01719 9.79866 2.61243 9.81395 3.32999V6.19999L19.5814 8.99998L28.6977 6.19999Z"
            fill="#0364B8"
          />
          <path d="M9.81395 6.19999H16.3256V12.5H9.81395V6.19999Z" fill="#0078D4" />
          <path
            d="M22.8372 6.19999H16.3256V12.5L22.8372 18.8H28.6977V12.5L22.8372 6.19999Z"
            fill="#28A8EA"
          />
          <path d="M16.3256 12.5H22.8372L22.8372 18.8H16.3256V12.5Z" fill="#0078D4" />
          <path d="M16.3256 18.8H22.8372L22.8372 25.1H16.3256V18.8Z" fill="#0364B8" />
          <path d="M9.9585 18.8518H16.3256V24.5554H9.9585L9.9585 18.8518Z" fill="#14447D" />
          <path d="M22.8372 18.8H28.6977L28.6977 25.1H22.8372L22.8372 18.8Z" fill="#0078D4" />
          <path
            d="M29.7017 17.2481L29.6894 17.2551L19.987 23.1211C19.9447 23.1491 19.9018 23.1757 19.8568 23.1995C19.692 23.2838 19.513 23.3314 19.3307 23.3395L18.8006 23.0063C18.7558 22.9821 18.7124 22.9552 18.6704 22.9258L8.83785 16.8932H8.83329L8.51162 16.7V28.5748C8.51663 29.367 9.11797 30.005 9.85496 30H28.6775C28.6885 30 28.6983 29.9944 28.71 29.9944C28.8657 29.9837 29.0191 29.9492 29.1658 29.8922C29.2292 29.8633 29.2904 29.8291 29.3488 29.79C29.3924 29.7634 29.4673 29.7053 29.4673 29.7053C29.8009 29.4399 29.9983 29.0209 30 28.5748L30 16.7C29.9998 16.9271 29.8858 17.1365 29.7017 17.2481Z"
            fill="url(#paint0_linear_4800_1348)"
          />
          <path
            d="M3.19358 8.29999H15.132C15.7912 8.29999 16.3256 8.87446 16.3256 9.58309V22.4169C16.3256 23.1255 15.7912 23.7 15.132 23.7H3.19358C2.53438 23.7 2 23.1255 2 22.4169V9.58309C2 8.87446 2.53439 8.29999 3.19358 8.29999Z"
            fill="url(#paint1_linear_4800_1348)"
          />
          <path
            d="M5.73051 13.6816C6.02469 13.0078 6.49952 12.444 7.09405 12.0625C7.75246 11.6573 8.50211 11.4553 9.26047 11.4787C9.96334 11.4623 10.6569 11.6538 11.2654 12.0324C11.8375 12.3992 12.2983 12.9366 12.5918 13.5794C12.9115 14.2877 13.0708 15.0672 13.0567 15.8544C13.0722 16.677 12.9083 17.4921 12.5781 18.2344C12.2776 18.9002 11.8022 19.4567 11.2107 19.8353C10.5787 20.2254 9.85944 20.422 9.13089 20.4037C8.413 20.4223 7.70415 20.2286 7.08168 19.8437C6.50461 19.4764 6.03805 18.9384 5.73768 18.2939C5.41613 17.5958 5.25493 16.825 5.26755 16.0462C5.25415 15.2305 5.41242 14.4222 5.73051 13.6816ZM7.1839 17.4826C7.34075 17.9085 7.60673 18.2779 7.95097 18.548C8.3016 18.8114 8.72146 18.9473 9.1491 18.9358C9.60453 18.9551 10.0534 18.8146 10.428 18.5354C10.7679 18.2662 11.0269 17.8958 11.1729 17.47C11.3362 16.9944 11.4168 16.4907 11.4106 15.9839C11.4156 15.4722 11.3399 14.9633 11.1866 14.4789C11.0512 14.0415 10.8005 13.6558 10.4651 13.3687C10.0999 13.0762 9.65224 12.9279 9.19729 12.9487C8.76038 12.9365 8.33112 13.0735 7.97116 13.34C7.62109 13.6112 7.35006 13.9838 7.18976 14.4145C6.83416 15.4016 6.83231 16.4955 7.18455 17.484L7.1839 17.4826Z"
            fill="white"
          />
          <path d="M22.8372 6.19999H28.6977L28.6977 12.5H22.8372L22.8372 6.19999Z" fill="#50D9FF" />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4800_1348"
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35B8F1" />
          <stop offset="1" stopColor="#28A8EA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4800_1348"
          x1="6.86417"
          y1="0.177114"
          x2="25.1358"
          y2="31.8229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1784D9" />
          <stop offset="0.5" stopColor="#107AD5" />
          <stop offset="1" stopColor="#0A63C9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
